<template>

  <b-card>
    <b-row>
      <b-col class="col-12 text-center">
        <!-- <h1>รายการเอกสาร DOC61/XXXXX ขอเอกสารเพิ่มเติม</h1> -->
        <h1>{{ message }}</h1>
      </b-col>

      <b-col class="mt-5 col-12  text-center">
        <h1 style="text-align:center;">
          ดำเนินการเรียบร้อยแล้ว
        </h1>
      </b-col>

      <b-col class="mt-5  col-12 text-center">
        <b-button
          variant="primary"
          @click="myRedirect()"
        >
          <span>กลับสู่หน้าหลัก</span>
        </b-button>
      </b-col>
    </b-row>

  </b-card>
</template>

<script>
import { BRow, BCol, BButton, BCard, } from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BCard,
  },
  beforeMount() {
    this.backComponentName = this.$route.query.backComponentName;
    this.message = this.$route.query.message;
  },
  data() {
    return {
      backComponentName : '',
      message: '',
    };
  },
  methods: {

    myRedirect() {
      const routeData = this.$router.resolve({ name: this.backComponentName })
      window.open(routeData.href, '_self')
    },
  },
  
}
</script>

 <style lang="scss" >

</style>
